import { UPLOAD } from '../actions/upload';

export default function uploadMiddleware(uploadFile, requestCredentials, requestFactory) {
  return (store) => (next) => async (action) => {
    const state = store.getState();
    const request = requestFactory(state);

    switch (action.type) {
      case UPLOAD: {
        const { file, name, type } = action.payload;
        const credentials = await requestCredentials(request, type);
        const uploadedFile = await uploadFile(name, file, type, credentials);
        await request.post(`/_api/media/index`, uploadedFile);
        return uploadedFile;
      }

      default:
        return next(action);
    }
  };
}
